import AnimatedGrid from "components/animation/hero/AnimatedGrid";
import React from "react";
import AboutElevated from "./components/AboutElevated";
import BestGym from "./components/BestGym";
import Client from "./components/Client";
import EarlyBird from "./components/EarlyBird";
import Facilities from "./components/Facilities";
import HeroSection from "./components/HeroSection";
import Instagram from "./components/Instagram";
import MobileApp from "./components/MobileApp";
import Posing from "./components/Posing";

function Home() {
  return (
    <div>
      <HeroSection />
      <AnimatedGrid />
      <BestGym />
      <AboutElevated />
      <MobileApp />
      <Facilities />
      <EarlyBird />
      <Client />
      <Instagram />
      <Posing />
    </div>
  );
}

export default Home;
